// import React, { useRef, useEffect } from 'react'; // 1. Import Hooks
// import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';
// import App from './App.jsx';
// import './index.css';
// import { HelmetProvider } from "react-helmet-async";
// import LoadingBar from 'react-top-loading-bar';
// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { setLoaderRef } from './components/utils/apiClient';
// import { OnboardingProvider } from './components/Onboarding/OnboardingContext';

// // --- SUPPRESS ResizeObserver loop limit exceeded error ---
// const originalError = console.error;
// console.error = (...args) => {
//   const msg = args[0] && typeof args[0] === 'string' ? args[0] : "";
//   if (msg.includes('ResizeObserver loop') || msg.includes('ResizeObserver limit exceeded')) {
//     return;
//   }
//   originalError(...args);
// };

// const hideResizeObserverError = (e) => {
//   const msg = e.message || (e.reason && e.reason.message) || "";
//   if (msg.includes('ResizeObserver loop') || msg.includes('ResizeObserver limit exceeded')) {
//     e.stopImmediatePropagation();
//     if (e.preventDefault) e.preventDefault();
//     return true;
//   }
//   return false;
// };

// window.addEventListener('error', hideResizeObserverError);
// window.addEventListener('unhandledrejection', hideResizeObserverError);
// // ---------------------------------------------------------

// //ReactGA.initialize("G-N98GGZRF");

// // 3. Create a Root component to handle the hooks
// const Root = () => {
//   const loadingBarRef = useRef(null);

//   useEffect(() => {
//     // Pass the ref to your Axios client
//     setLoaderRef(loadingBarRef.current);
//   }, []);

//   return (
//     <HelmetProvider>
//       <BrowserRouter>
//         <OnboardingProvider>
//           {/* The Top Bar Loader */}
//           <LoadingBar color="#078330" ref={loadingBarRef} height={3} />

//           {/* The Alert Container */}
//           <ToastContainer position="top-right" autoClose={3000} />

//           <App />
//         </OnboardingProvider>
//       </BrowserRouter>
//     </HelmetProvider>
//   );
// };

// // 4. Render the Root component
// ReactDOM.createRoot(document.getElementById('root')).render(<Root />);

import React, { useRef, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.jsx";
import "./index.css";
import { HelmetProvider } from "react-helmet-async";
import LoadingBar from "react-top-loading-bar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { setLoaderRef } from "./components/utils/apiClient";
import { OnboardingProvider } from "./components/Onboarding/OnboardingContext";

// 🚨 THE ULTIMATE RESIZEOBSERVER FIX 🚨
// Instead of hiding the error, we intercept the ResizeObserver and force it
// to wait for the next animation frame. This prevents the micro-loop from
// ever happening, stopping the Webpack red screen entirely!
const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        try {
          callback(entries, observer);
        } catch (e) {
          // Silently catch any internal errors during the animation frame
        }
      });
    });
  }
};
// ---------------------------------------------------------

//ReactGA.initialize("G-N98GGZRF");

const Root = () => {
  const loadingBarRef = useRef(null);

  useEffect(() => {
    // Pass the ref to your Axios client
    setLoaderRef(loadingBarRef.current);
  }, []);

  return (
    <HelmetProvider>
      <BrowserRouter>
        <OnboardingProvider>
          {/* The Top Bar Loader */}
          <LoadingBar color="#078330" ref={loadingBarRef} height={3} />

          {/* The Alert Container */}
          <ToastContainer position="top-right" autoClose={3000} />

          <App />
        </OnboardingProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<Root />);
